<template>
    <div>
        <template v-if="!componentIsLoading">
            <h5>Salarié(s)</h5>

            <errors :items="errors"
                @errors-closed="resetErrors"
            ></errors>

            <form v-if="fields.length > 0">
                <div class="form-group">
                    <custom-checkbox :field="getField('customer.without_employee')" 
                        :value="socialCertificate.customer.without_employee"
                        :field_idx="'customer.without_employee'"
                        @field-updated="$emit('field-updated', $event)" 
                        :as_number="false">
                    </custom-checkbox>
                </div>
            </form>

            <div class="buttons clearfix">
                <button class="btn btn-default btn-sm"
                    @click="$emit('current-step-changed', 'social-address')"
                >
                    Précédent
                </button>
                
                <button class="btn btn-success btn-sm pull-right"
                    @click="validateCurrentStep"
                >
                    Suivant
                </button>
            </div>
        </template>

        <component-loader v-else></component-loader>
    </div>
</template>

<script>
    import api from 'store/api'
    import formStepMixin from "mixins/socialCertificateFormStep";
    import Errors from './Errors'
    import CustomCheckbox from "components/Forms/Elements/Checkbox"
    import ComponentLoader from 'components/ComponentLoader'

    export default {
        mixins: [
            formStepMixin
        ],

        components: {
            Errors, 
            CustomCheckbox,
            ComponentLoader
        },

        props: {
            socialCertificate: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                componentIsLoading: false,
                fields: [],
            }
        },

        created() {
            this.componentIsLoading = true

            api.getCustomerSocialCertificateEditionSchema(this.profile.id, 'customer_employees')
                .then((response) => {
                    if (response.data.schema && response.data.schema.hasOwnProperty('fields')) {
                        this.fields = response.data.schema.fields
                    }

                    this.componentIsLoading = false
                })
        },

        methods: {
            validateCurrentStep() {
                if (this.validateCustomerEmployeeStep()) {
                    this.$emit('current-step-changed', 'form-summary')
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/SocialCertificate/EditionForm/CustomerEmployeesStep.vue